class MenuVertical extends HTMLElement {
  constructor() {
    super();

    this.animationOptions = {
      duration: 500,
      timingFunction: 'ease',
    };

    this.querySelectorAll('[data-toggle="submenu"]').forEach((button) => {
      const item = button.closest('li');

      if (item.classList.contains('active')) {
        this.openSubMenu(item);
      }

      button.addEventListener('click', (e) => {
        e.preventDefault();

        item.classList.contains('active') ? this.closeSubMenu(item) : this.openSubMenu(item);
      });
    });
  }

  openSubMenu(item) {
    const subMenu = item.querySelector(':scope > ul');

    item.classList.add('active');
    subMenu.setAttribute('aria-hidden', 'false');
    subMenu.setAttribute('aria-expanded', 'true');

    slideDown(subMenu, this.animationOptions.duration, this.animationOptions.timingFunction);
  }

  closeSubMenu(item) {
    const subMenu = item.querySelector(':scope > ul');

    item.classList.remove('active');
    subMenu.setAttribute('aria-hidden', 'true');
    subMenu.setAttribute('aria-expanded', 'false');

    slideUp(subMenu, this.animationOptions.duration, this.animationOptions.timingFunction);
  }
}

customElements.define('menu-vertical', MenuVertical);
